import VideosPage from '@modules/professional/page/VideosPage';
import { loader } from '@modules/professional/page/loaders/videos-page-loader.server';
import { mergeMeta } from '~/modules/seo';
import { createVideoSchema } from '~/modules/seo/schema/video-schema';
import { createLDSchema } from '~/modules/seo/util/create-ld-schema';
import dayjs from 'dayjs';

export const meta = mergeMeta<typeof loader>(
    (_props) => {
        return [];
    },

    (props) => {
        const videoSchemas =
            props.data?.companyVideosResult?.videos.map((video) => {
                return createVideoSchema({
                    name: video?.caption ?? '',
                    publishDate: dayjs(video?.publishDate).isValid()
                        ? dayjs(video?.publishDate).toISOString()
                        : ' ',
                    professionalName: video.caption ?? '',
                    url: video?.src ?? '',
                    thumbnailUrl: video?.coverImage.src ?? '',
                    description: video.caption ?? '',
                });
            }) ?? [];

        const ldSchema = createLDSchema(videoSchemas);

        return [...ldSchema];
    }
);

export { loader };
export default VideosPage;
